import { render, staticRenderFns } from "./MyNextMoveWrapper.vue?vue&type=template&id=23a614ad&scoped=true"
import script from "./MyNextMoveWrapper.vue?vue&type=script&lang=ts"
export * from "./MyNextMoveWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a614ad",
  null
  
)

export default component.exports